import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const SubmitButton = (props: {
  submit: boolean;
  submitText?: string | React.ReactNode;
  className: string;
  handleSubmit?: () => void;
  variant?: 'outlined' | 'contained' | 'text';
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'inherit';
  disabled?: boolean;
  handleClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  dataEleId?: string;
  dataEleGroup?: string;
  isDelete?: boolean;
  id?: string;
  disabledClassName?: string;
}) => {
  const {
    submit,
    variant = 'contained',
    handleSubmit,
    className,
    disabled = false,
    handleClick,
    dataEleId,
    dataEleGroup,
    isDelete = false,
    submitText = isDelete ? '删除' : '确认',
    color,
    id,
    disabledClassName = 'disabled:!bg-web-blue-500 disabled:!text-white',
  } = props;

  React.useEffect(() => {
    if (submit) {
      handleSubmit?.();
    }
  }, [submit]);

  return (
    <Button
      id={id}
      variant={variant}
      fullWidth
      type="submit"
      color={color}
      data-ele-id={dataEleId}
      data-ele-group={dataEleGroup}
      className={`${className} !min-w-[100px] ${isDelete ? '!bg-web-alert-800 disabled:!bg-web-alert-800 disabled:!text-white' : disabledClassName} disabled:!opacity-80`}
      disabled={disabled || submit}
      startIcon={
        submit ? (
          <CircularProgress
            size={20}
            thickness={4}
            className="!text-white !mr-0.5"
          />
        ) : undefined
      }
      onClick={handleClick}
    >
      {submitText}
    </Button>
  );
};

export default SubmitButton;
